import { render, staticRenderFns } from "./CustomDocGrid.vue?vue&type=template&id=55366d36&"
import script from "./CustomDocGrid.vue?vue&type=script&lang=js&"
export * from "./CustomDocGrid.vue?vue&type=script&lang=js&"
import style0 from "./CustomDocGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports